import React from "react";

interface DatabaseProps {
  className?: string;
  size?: number;
}

const Database: React.FC<DatabaseProps> = ({ className = "", size = 20 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="12"
        cy="5"
        rx="9"
        ry="3"
        stroke="white"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M3 5v14c0 1.657 4.03 3 9 3s9-1.343 9-3V5"
        stroke="white"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M3 12c0 1.657 4.03 3 9 3s9-1.343 9-3"
        stroke="white"
        strokeWidth="2"
        fill="none"
      />
    </svg>
  );
};

export default Database;
